/* eslint-disable no-unused-expressions */
/*
 * @Description: In User Settings Edit
 * @Author: yangkeqiang
 * @LastEditors: yangkeqiang
 * @Date: 2019-04-24 11:15:38
 * @LastEditTime: 2019-04-24 11:15:38
 */
import request from "@/plugins/axios/request";
// 获取职位信息分页
export function queryjobposition(guestbook) {
    return request({
        url: "/jobposition/queryjobposition",
        method: "post",
        data: guestbook
    });
}
// 通过id职位信息
export function queryJobPositionById(guestbook) {
    return request({
        url: "/jobposition/queryjobpositionbyid",
        method: "post",
        data: guestbook
    });
}
// 省市信息
export function queryprovinceandcity(id) {
    return request({
        url: "/jobposition/queryprovinceandcity",
        method: "post",
        data: { id: id }
    });
}
